
            const data = {"name":"calendar-1","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"M448 64h-64V21h-43v128h43v-42h64v320H64V107h43V64H64c-24 0-43 19-43 43v320c0 23 19 42 43 42h384c24 0 43-19 43-42V107c0-24-19-43-43-43zm-277 43h149V64H171V21h-43v128h43zm-64 85h85v85h-85zm106 0h86v85h-86zm107 0h85v85h-85zM107 299h85v85h-85zm106 0h86v85h-86z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    